import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import { LogoProvider } from './LogoProvider';
import * as iconSources from './iconSources';
import { HttpClient } from '@wix/http-client';
export var DEFAULT_SEARCH_LIMIT = 300;
var DEFAULT_SEARCH_OFFSET = 0;
export var NounProjectProvider = /*#__PURE__*/function (_LogoProvider) {
  _inheritsLoose(NounProjectProvider, _LogoProvider);

  function NounProjectProvider(webappApi, options) {
    var _this;

    _this = _LogoProvider.call(this, iconSources.NOUN_PROJECT_SOURCE) || this;
    _this.webappApi = webappApi;
    _this.options = options;
    _this._httpClient = new HttpClient();
    return _this;
  }

  var _proto = NounProjectProvider.prototype;

  _proto.getSVG = /*#__PURE__*/function () {
    var _getSVG = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var iconUrl, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              iconUrl = _ref.iconUrl;
              _context.prev = 1;
              _context.next = 4;
              return this._httpClient.get(iconUrl, {
                // Solves weird bug where sometimes the download fails if it gets from cache
                headers: {
                  'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=-1,private'
                },
                disableWixHeaders: true
              });

            case 4:
              response = _context.sent;
              _context.next = 12;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);
              _context.next = 11;
              return this._httpClient.get(iconUrl, {
                disableWixHeaders: true
              });

            case 11:
              response = _context.sent;

            case 12:
              return _context.abrupt("return", response.data);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[1, 7]]);
    }));

    function getSVG(_x) {
      return _getSVG.apply(this, arguments);
    }

    return getSVG;
  }();

  _proto.hasDefault = function hasDefault() {
    return false;
  };

  _proto.translateTerm = /*#__PURE__*/function () {
    var _translateTerm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(term) {
      var _translateTerm2$data$, _translateTerm2$data, mountPoint, url, httpClient, _translateTerm2;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              mountPoint = this.options.basename || window.__BASE_PATH__;
              url = "/api/translateText?q=" + term;
              httpClient = new HttpClient({
                baseURL: mountPoint
              });
              _context2.next = 6;
              return httpClient.get(url);

            case 6:
              _translateTerm2 = _context2.sent;
              return _context2.abrupt("return", (_translateTerm2$data$ = _translateTerm2 == null ? void 0 : (_translateTerm2$data = _translateTerm2.data) == null ? void 0 : _translateTerm2$data.translated) != null ? _translateTerm2$data$ : term);

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              return _context2.abrupt("return", term);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 10]]);
    }));

    function translateTerm(_x2) {
      return _translateTerm.apply(this, arguments);
    }

    return translateTerm;
  }();

  _proto._searchIconsByTerm = /*#__PURE__*/function () {
    var _searchIconsByTerm2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(term, limit, offset, options) {
      var filteredTerm;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (limit === void 0) {
                limit = 100;
              }

              filteredTerm = term.replace('/', ' ');

              if (options.skipTranslate) {
                _context3.next = 6;
                break;
              }

              _context3.next = 5;
              return this.translateTerm(filteredTerm);

            case 5:
              filteredTerm = _context3.sent;

            case 6:
              return _context3.abrupt("return", this.webappApi.searchNounProjectIcons(filteredTerm, limit, offset));

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function _searchIconsByTerm(_x3, _x4, _x5, _x6) {
      return _searchIconsByTerm2.apply(this, arguments);
    }

    return _searchIconsByTerm;
  }();

  _proto.searchIcons = /*#__PURE__*/function () {
    var _searchIcons = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(arrSearchTerms, options) {
      var _this2 = this;

      var cleanedArrSearchTerms, hasSearchTerms, results, limit, offset, searchPromises, resultsBefore;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (options === void 0) {
                options = {};
              }

              cleanedArrSearchTerms = arrSearchTerms.filter(function (searchTerm) {
                return !!searchTerm;
              });
              hasSearchTerms = cleanedArrSearchTerms && Array.isArray(cleanedArrSearchTerms) && cleanedArrSearchTerms.length && cleanedArrSearchTerms.some(function (term) {
                return term;
              });
              results = [];
              limit =
              /* options.limit || */
              DEFAULT_SEARCH_LIMIT;
              offset = options.offset || DEFAULT_SEARCH_OFFSET;

              if (!hasSearchTerms) {
                _context4.next = 13;
                break;
              }

              searchPromises = [];
              cleanedArrSearchTerms.forEach(function (term) {
                searchPromises.push(_this2._searchIconsByTerm(term, limit, offset, options));
              });
              _context4.next = 11;
              return Promise.all(searchPromises);

            case 11:
              resultsBefore = _context4.sent;
              results = resultsBefore.map(function (searchResult) {
                return searchResult.icons;
              }).reduce(function (before, currentSearch) {
                return [].concat(before, currentSearch);
              }, []);

            case 13:
              return _context4.abrupt("return", results);

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function searchIcons(_x7, _x8) {
      return _searchIcons.apply(this, arguments);
    }

    return searchIcons;
  }();

  _proto.getIconById = function getIconById(id) {
    return this.webappApi.fetchNounIconById(id);
  };

  return NounProjectProvider;
}(LogoProvider);